function MusicIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19Z"
        stroke="#1C274C"
        strokeWidth="1.5"
        className="stroke"
      />
      <path
        d="M21 17C21 18.6569 19.6569 20 18 20C16.3431 20 15 18.6569 15 17C15 15.3431 16.3431 14 18 14C19.6569 14 21 15.3431 21 17Z"
        stroke="#1C274C"
        strokeWidth="1.5"
        className="stroke"
      />
      <path d="M9 19V8" stroke="#1C274C" strokeWidth="1.5" className="stroke" />
      <path
        d="M21 17V6"
        stroke="#1C274C"
        strokeWidth="1.5"
        className="stroke"
      />
      <path
        d="M15.7351 3.7549L11.7351 5.08824C10.4151 5.52825 9.75503 5.74826 9.37752 6.27203C9 6.79581 9 7.49153 9 8.88297V11.9999L21 7.99993V7.54964C21 5.01718 21 3.75095 20.1694 3.1523C19.3388 2.55365 18.1376 2.95407 15.7351 3.7549Z"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="stroke"
      />
    </svg>
  );
}

export default MusicIcon;
